import { useCallback, useEffect,useState } from "react";
import axiosInstance from "../services/axiosInstance";
//import { FaEdit } from "react-icons/fa";
import Loader from "../components/Loader";
import { useLocation } from "react-router-dom";

export default function AttendanceLog({ staffData }) {

  const location = useLocation();
  const navStaff = location.state?.staffData;
  const selectedData = staffData || navStaff;

  const [records,setRecords] = useState([]);
  const [selected,setSelected] = useState(null);
  const [loading,setLoading] = useState(false);
  const [attendanceStatus,setAttendanceStatus] = useState("PRESENT");
  const [remarks,setRemarks] = useState("");
  const [range,setRange] = useState({});

  const staffId = selectedData.id || "";
  const staffCode = selectedData.employeeCode || "";
  const staffName = selectedData.employeeName || "";

  // Generate date ranges
  const getDateRanges = () => {

    const today = new Date();

    const last30Start = new Date();
    last30Start.setDate(today.getDate() - 30);

    const getMonthRange = (date) => {

      const start = new Date(date.getFullYear(),date.getMonth(),1);
      const end = new Date(date.getFullYear(),date.getMonth()+1,0);

      return {
        startDate:start.toISOString().split("T")[0],
        endDate:end.toISOString().split("T")[0]
      };
    };

    const months = [];

    for(let i=1;i<=3;i++){

      const d = new Date(today.getFullYear(),today.getMonth()-i,1);

      months.push({
        label:d.toLocaleString("default",{month:"short"}).toUpperCase(),
        ...getMonthRange(d)
      });
    }

    return [
      {
        label:"30 DAYS",
        startDate:last30Start.toISOString().split("T")[0],
        endDate:today.toISOString().split("T")[0]
      },
      ...months
    ];
  };

  const ranges = getDateRanges();
// Set default range
useEffect(() => {
  if (ranges.length > 0 && !range.startDate) {
    setRange(ranges[0]);
  }
}, [ranges, range.startDate]);

// ✅ Memoized function
const loadAttendance = useCallback(async () => {
  try {
    setLoading(true);

    const res = await axiosInstance.get(
      `/attendance/${staffId}?startDate=${range.startDate}&endDate=${range.endDate}`
    );

    setRecords(res.data);
  } catch (err) {
    alert("Failed to load Staff, Please retry");
  } finally {
    setLoading(false);
  }
}, [staffId, range.startDate, range.endDate]); // 👈 IMPORTANT deps

useEffect(() => {
  if (!range.startDate) return;
  loadAttendance();
}, [loadAttendance, selectedData, range.startDate]);

  const getStatusStyle = (status) => {
    switch (status) {
      case "PRESENT":
         return "bg-green-100 text-green-500";
      case "REG":
        return "bg-blue-100 text-blue-700";

      case "ABSENT":
        return "bg-red-100 text-red-700";

      case "LEAVE":
        return "bg-yellow-100 text-yellow-700";

      case "HLDY":
        return "bg-green-100 text-green-700";
        
      case "HALF_DAY":
        return "bg-green-100 text-green-700";

      case "W-OFF":
        return "bg-gray-200 text-gray-700";

      default:
        return "bg-gray-100 text-gray-600";
    }
  };
  const isWeekend = (date) => {
    const d = new Date(date).getDay();
    return d === 0 || d === 6;
  };
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "2-digit",
    });
  };

  const saveAttendance = async () => {

    try{

      await axiosInstance.put("/attendance/update", {
        id: selected.id,
        status: attendanceStatus,
        remarks: remarks
      });

      alert("Attendance Updated Successfully");

      setSelected(null);
      loadAttendance();

    }catch(err){

      alert("Failed to update attendance");

    }
  };

  return (

    <div className="bg-white rounded-xl shadow">

      {loading && <Loader/>}

      {/* Header */}

      <div className="flex justify-between items-center p-4 border-b">

        <h2 className="font-semibold text-lg">
          Log
        </h2>

        <div className="flex gap-2">

          {ranges.map((r)=>(
            <button
              key={r.label}
              onClick={()=>setRange(r)}
              className={`px-3 py-1 rounded text-sm
              ${range.label===r.label
                ?"bg-blue-600 text-white"
                :"bg-gray-200"}`}
            >
              {r.label}
            </button>
          ))}

        </div>

      </div>

      {/* Table */}

      <div className="overflow-x-auto">

        <table className="w-full text-sm">

          <thead className="bg-gray-50 text-gray-600">
            <tr>
              <th className="p-3 text-left">Date</th>
              {/* <th className="p-3 text-left">Login</th>
              <th className="p-3 text-left">Logout</th> */}
              <th className="p-3 text-left">Status</th>
              <th></th>
            </tr>
          </thead>

          <tbody>

            {records.map((r)=>{

              return(

                <tr key={r.id}  className={`border-t hover:bg-gray-50 ${isWeekend(r.attendanceDate) ? "bg-gray-100" : ""}`}>
                  <td className="p-3 font-medium text-gray-700">
                    {formatDate(r.attendanceDate)}
                  </td>

                  {/* <td className="p-3">{r.loginTime || "-"}</td>

                  <td className="p-3">{r.logoutTime || "-"}</td> */}

                 <td className="p-3">
                  <span
                    className={`px-2 py-1 rounded text-xs font-semibold ${getStatusStyle(
                      r.status
                    )}`}
                  >
                    {r.status}
                  </span>
                </td>

                  {/* <td className="p-3 text-right">

                    <button
                      onClick={()=>{

                        setSelected(r);
                        setAttendanceStatus(r.status);
                        setRemarks(r.remarks || "");

                      }}
                      className="text-gray-500 hover:text-black"
                    >
                      <FaEdit/>
                    </button>

                  </td> */}

                </tr>

              );

            })}

          </tbody>

        </table>

      </div>

      {/* Edit Popup */}

      {selected && (

        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">

          <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl p-6 relative">

            <button
              onClick={()=>setSelected(null)}
              className="absolute top-4 right-4 text-gray-500 hover:text-black"
            >
              ✕
            </button>

            <h2 className="text-2xl font-bold mb-6">
              Staff Attendance
            </h2>

            <div className="grid grid-cols-3 gap-4 text-sm">

              <div>
                <label className="font-semibold text-xs">Employee Code</label>
                <input
                  value={staffCode}
                  disabled
                  className="w-full border rounded p-1.5 bg-gray-100"
                />
              </div>

              <div>
                <label className="font-semibold text-xs">Employee Name</label>
                <input
                  value={staffName}
                  disabled
                  className="w-full border rounded p-1.5 bg-gray-100"
                />
              </div>

              <div>
                <label className="font-semibold text-xs">Date</label>
                <input
                  type="date"
                  value={selected.attendanceDate}
                  disabled
                  className="w-full border rounded p-1.5 bg-gray-100"
                />
              </div>

              <div>
                <label className="font-semibold text-xs">Attendance Status</label>
                <select
                  value={attendanceStatus}
                  onChange={(e)=>setAttendanceStatus(e.target.value)}
                  className="w-full border rounded p-1.5"
                >
                  <option value="PRESENT">Present</option>
                  <option value="ABSENT">Absent</option>
                  <option value="LEAVE">Leave</option>
                  <option value="HALF_DAY">Half Day</option>
                </select>
              </div>

              <div className="col-span-2">
                <label className="font-semibold text-xs">Remarks</label>
                <input
                  value={remarks}
                  onChange={(e)=>setRemarks(e.target.value)}
                  className="w-full border rounded p-1.5"
                />
              </div>

            </div>

            <div className="flex justify-end gap-3 mt-6">

              <button
                onClick={()=>setSelected(null)}
                className="px-4 py-2 bg-gray-300 rounded"
              >
                Cancel
              </button>

              <button
                onClick={saveAttendance}
                className="px-4 py-2 bg-green-600 text-white rounded"
              >
                Save Attendance
              </button>

            </div>

          </div>

        </div>

      )}

    </div>

  );

}